
























import { defineComponent } from "@nuxtjs/composition-api";
import type { PropType } from "@nuxtjs/composition-api";
import { SfButton } from "@storefront-ui/vue";
import type { NuxtError } from "@nuxt/types";

export default defineComponent({
  components: {
    SfButton,
  },
  props: {
    error: {
      type: Object as PropType<NuxtError>,
      required: true,
    },
  },
  head() {
    return {
      htmlAttrs: {
        lang: "vi",
      },
      title: "404 Page Not Found",
    };
  },
});
